module.exports = "<i class=\"js-edit-button editor__icons icon-edit fa fa-edit\"></i>\n";